<template>
  <l-marker :lat-lng="[packet.satPos.lat, packet.satPos.lng]" :icon="icon">
    <l-popup>
      <h3>
        <router-link v-if="packet.packetId" :to="`/packet/${packet.packetId}`">
          <v-icon>$satelliteDark</v-icon>{{ packet.parsed ? packet.satellite : "unknown" }}
        </router-link>
        <div v-else>
          <v-icon>$satelliteDark</v-icon> {{ packet.parsed ? packet.satellite : "unknown" }}
        </div>
      </h3>
      <br>
      <strong>⏱ Time:</strong> {{ formatTime(packet.serverTime) }}<br>
      <strong>📏 Distance:</strong> {{ (packet.station.distance || 0).toFixed(0) }} Km<br>
      <strong>📐 Elevation:</strong> {{ packet.station.elevation ? packet.station.elevation.toFixed(2) + "º" : "- -" }}<br>
      <strong>🧭 Azimuth:</strong> {{ packet.station.azimuth ? packet.station.azimuth.toFixed(2) + "º" : "- -" }}<br>
      <strong>📶 RSSI:</strong> {{ packet.station.receptionParams.rssi }} dBm<br>
      <strong>📶 SNR:</strong> {{ packet.station.receptionParams.snr }} dB<br>
      <strong>↕️ Freq error:</strong> {{ (packet.station.receptionParams.frequency_error).toFixed(0) }} Hz<br>
    </l-popup>
  </l-marker>
</template>

<script setup>
import { LMarker, LPopup } from "vue2-leaflet";
import { defineProps } from "vue";
import moment from "moment";
// If you want to use icons from the composable, import as below:
// import { useMapIcons } from "./composables/useMapIcons";
// const { satelliteIconNT, ... } = useMapIcons();

defineProps({
  packet: {
    type: Object,
    required: true
  },
  icon: {
    type: Object,
    required: true
  }
});

function formatTime(time) {
  return moment(time).format("lll");
}
</script>